<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  watch: {},
  created() { },
  methods: {},
  computed: {},
};
</script>
<style>
body,
p {
  margin: 0;
  padding: 0
}
</style>
